//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { noticeTemplateTypes, candidateUserAtributes } from '../../../../views/workflow/common';
import { throttle } from '@/utils/util';
import selectMetaDialogVue from '../../../../views/workflow/component/select-meta-dialog.vue';
import RichEditor from '@/components/richEditor';
import InputJson from '@/components/inputJson';
import Clipboard from 'nges-common/src/web/components/Clipboard';
import CodeEditor from '../../../../views/notice/noticeDetail/editor.vue';
import MessageBox from '@/components/messageBox';
import { difference } from 'lodash';
const _ = { difference };
export default {
  components: {
    selectMetaDialogVue,
    RichEditor,
    InputJson,
    Clipboard,
    CodeEditor,
    MessageBox,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      noticeTemplateTypes,
      candidateUserAtributes,
      visible: false,
      basicInfo: {
        name: '',
        keys: [],
        event_key: '',
        remark: '',
        subref: '',
        wxmsg_type: 1,
        system_type: '',
      },
      templateInfo: {
        title: '',
        content: '',
        to: [],
        to2: '',
        variable: '',
        platform: [1, 2],
        editor_type: 1,
        script: '',
      },
      candidateUserList: [],
      insertType: '',
      objectNames: [],
      copytext: '',
      documentLink:
        'https://developer.work.weixin.qq.com/document/path/90236#%E5%B0%8F%E7%A8%8B%E5%BA%8F%E9%80%9A%E7%9F%A5%E6%B6%88%E6%81%AF',
      systemMessageTypeList: [],
      // 代码输入框配置
      htmlOptions: {
        placeholder: '<html></html>',
        autorefresh: true,
        mode: 'text/html',
        matchBrackets: true,
        tabSize: 4,
        lineNumbers: true,
        lineWrapping: true,
      },
      jsOptions: {
        placeholder: 'var a = 1',
        autorefresh: true,
        mode: 'text/javascript',
        matchBrackets: true,
        tabSize: 4,
        lineNumbers: true,
        lineWrapping: true,
      },
      // 校验规则
      templateInfoFormRule: {
        title: [{ required: true, message: '请输入通知标题', trigger: 'blur' }],
        content: [
          { required: true, message: '请输入通知内容' },
          {
            validator: (rule, value, callback) => {
              const err = this.validateContent();
              if (err) {
                callback(err);
              } else {
                callback();
              }
            },
          },
        ],
        platform: [{ required: true, message: '请选择通知终端 ', trigger: 'change' }],
      },
    };
  },
  computed: {
    generateTo2() {
      if (!this.templateInfo.to2) {
        return [];
      }
      return this.templateInfo.to2 === 'specify_variable'
        ? [this.templateInfo.variable]
        : [this.templateInfo.to2];
    },
    generateToType() {
      if (!this.templateInfo.to2) {
        return 0;
      }
      return this.templateInfo.to2 === 'specify_variable' ? 2 : 1;
    },
    previewContent() {
      return this.templateInfo.content.replaceAll('href="mailto', '');
    },
    // 只选了站内信的时候,需要选择终端
    needPlatform() {
      return this.basicInfo.subref === 'lclmsg';
    },
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {
    this.getObjectByRelatedWorkflow();
    this.getSystemMessageTypes();
  },
  methods: {
    onSubrefChange() {
      this.templateInfo.content = '';
    },
    openDiaLog() {
      this.basicInfo.keys = [this.info.process_key];
      this.getObjectByRelatedWorkflow();
      this.visible = true;
    },
    beforeClose() {
      this.basicInfo = {
        name: '',
        keys: [],
        remark: '',
        subref: '',
        wxmsg_type: 1,
        system_type: '',
        module: '',
      };
      this.templateInfo = {
        title: '',
        content: '',
        to: [],
        to2: '',
        variable: '',
        editor_type: 1,
        platform: [1, 2],
        script: '',
      };
      this.candidateUserList = [];
      this.$refs.basicForm.clearValidate();
      this.$refs.templateForm.clearValidate();
      this.visible = false;
    },
    handleCloseCreateDia() {
      this.beforeClose();
    },
    createNoticeEvent(data) {
      this.$request({
        url: this.$api.createProcessAction,
        data,
      }).then(async (res) => {
        if (res.id) {
          await this.$emit('getEventOptions');
          this.$emit('addEventValue', res.id);
          this.beforeClose();
          this.$message.success('创建成功');
        }
      });
    },
    getCandidateUserList(name = '', delay = 300) {
      if (!name) {
        this.candidateUserList = this.templateInfo?.to?.map((value) => {
          return {
            value,
            label: value.replace(/\((.+?)\)/g, ''),
          };
        });
        return;
      }
      throttle(() => {
        this.$request({
          url: this.$api.getUserList,
          data: {
            page_size: 100,
            page: 1,
            keyword: name,
          },
          showLoading: false,
          cb: ({ data }) => {
            if (data) {
              const map = {};
              this.candidateUserList = [
                ...(this.templateInfo.to || []).map((value) => ({
                  value,
                  label: value.replace(/\((.+?)\)/g, ''),
                })),
                ...data.map((item) => ({
                  label: `${item.name}${item.description ? `-${item.description}` : ''}`,
                  value: `(${item.account})${item.name}${
                    item.description ? `-${item.description}` : ''
                  }`,
                })),
              ].reduce((prev, cur) => {
                map[cur.value] ? '' : (map[cur.value] = true && prev.push(cur));
                return prev;
              }, []);
            } else {
              this.candidateUserList = [];
            }
          },
        });
      }, delay).call(this);
    },
    getObjectByRelatedWorkflow() {
      this.$request({
        url: this.$api.metaGetObjectByRelatedWorkflow,
        data: {
          process_def_key: this.info.process_key,
        },
        cb: ({ list }) => {
          this.objectNames = list.map((i) => i.name);
        },
      });
    },
    submit() {
      this.$refs.basicForm.validate((basicValid) => {
        this.$refs.templateForm.validate((templateValid) => {
          if (!templateValid || !basicValid) {
            return;
          }
          if (!this.templateInfo.to.length && !this.templateInfo.to2) {
            this.$message.error('接收人设置至少选填一项');
            return;
          }
          if (this.templateInfo.to2 === 'specify_variable' && !this.templateInfo.variable) {
            this.$message.error('请输入指定变量');
            return;
          }
          const detailData = {
            category: 1, // 1是通知事件， 2是云函数
            name: this.basicInfo.name,
            remark: this.basicInfo.remark,
            event_key: this.basicInfo.event_key,
            status: 1,
            template: {
              notify: {
                editor_type: this.templateInfo.editor_type,
                script: this.templateInfo.script,
                title: this.templateInfo.title,
                platform: this.templateInfo.platform,
                content: this.templateInfo.content,
                to: this.templateInfo.to,
                to2: this.generateTo2,
                to_type: this.generateToType,
                subref: this.basicInfo.subref,
                wxmsg_type: this.basicInfo.wxmsg_type || undefined,
                system_type: this.basicInfo.system_type || undefined,
              },
            },
          };

          this.createNoticeEvent(detailData);
        });
      });
    },
    openMetaDiagLog(type) {
      this.insertType = type;
      this.$refs.metaDialog.openDialog();
    },

    insertion(str = '') {
      let selector = '';
      let field = '';
      if (this.insertType === 'title') {
        selector = '.notice-title .el-input__inner';
        field = 'title';
        const dom = document.querySelector(selector);
        this.templateInfo[field] = `${
          this.templateInfo[field].substring(0, dom.selectionStart) +
          str +
          this.templateInfo[field].substring(dom.selectionEnd, dom.textLength)
        }`;
      } else if (this.insertType === 'content' && this.basicInfo.subref !== 'wxmsg') {
        this.templateInfo.content += str;
      } else if (
        this.insertType === 'content' &&
        this.basicInfo.subref === 'wxmsg' &&
        this.basicInfo.wxmsg_type !== 1
      ) {
        this.copytext = str;
        this.$refs.copy.copy();
      } else {
        selector = '.notice-content .el-textarea__inner';
        field = 'content';
        const dom = document.querySelector(selector);
        this.templateInfo[field] = `${
          this.templateInfo[field].substring(0, dom.selectionStart) +
          str +
          this.templateInfo[field].substring(dom.selectionEnd, dom.textLength)
        }`;
      }
    },
    getSystemMessageTypes() {
      this.$request({
        url: this.$api.metaGetObjectByName,
        data: {
          objects: ['message'],
        },
        cb: ({ list }) => {
          if (list.length) {
            const field = list[0].fields.filter(({ name }) => name === 'type');
            this.systemMessageTypeList = field[0].select_one_option.options;
          }
        },
      });
    },
    emailMsgTypeChange() {
      this.templateInfo.content = '';
    },
    openPreview() {
      this.$refs.previewBox.show({
        title: '预览',
        width: '960px',
        top: '30vh',
        confirmText: '返回',
        exitButton: true,
        confirmAction: this.$refs.previewBox.close,
      });
    },
    openHelp() {
      this.$refs.helpBox.show({
        title: '帮助',
        width: '960px',
        top: '30vh',
        confirmText: '返回',
        exitButton: true,
        confirmAction: this.$refs.helpBox.close,
      });
    },
    validateContent() {
      if (this.needPlatform) {
        const platformFlagMap = { 1: 'wx', 2: 'web' };
        const platforms = (this.templateInfo.platform || []).map((item) => platformFlagMap[item]);
        const { content } = this.templateInfo;
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, 'text/html');
        const links = doc.querySelectorAll('a');
        const hrefs = Array.from(links).map(function (link) {
          return link.getAttribute('href');
        });
        if (hrefs.length) {
          for (let i = 0; i < hrefs.length; i++) {
            const href = hrefs[i];
            const regex = /\[\(([a-zA-Z0-9]+)\).*?\]/g;
            let match;
            const plats = [];
            while ((match = regex.exec(href)) !== null) {
              plats.push(match[1]);
            }
            // 如果勾选了，而没有配对应平台的链接，则报错
            if (_.difference(platforms, plats).length) {
              return new Error('请确保为每个选中的终端填写对应的链接。');
            }
            if (_.difference(plats, platforms).length) {
              return new Error('请选择超链接对应的通知终端。');
            }
          }
        }
      }
      return null;
    },
  },
};
